import { z } from 'zod';

export const examBoardSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
});

export const examBoardListSchema = z.array(examBoardSchema);

export type ExamBoard = z.infer<typeof examBoardSchema>;
